import React from 'react'

const Copyright = ({view} : {view: "company" | "talent"}) => {
  return (
    <div className="px-2 py-6 md:mx-6 flex justify-end gap-4 alu-text-base-1 text-xs leading-[1.125rem]">
      <span>© rakumo Inc.</span>
      {view !== "company" && <span>|</span>}
      {view !== "company" && <a href="https://share-na2.hsforms.com/1AZMLvLR4QWuPNbjqJYmfRAt77xr" target="_blank" className="underline hover:text-[#FF861A] z-[9]">
        お問い合わせ
      </a>}
    </div>
  )
}

export default Copyright